import { branch } from '@ourbranch/brand-product';
import { withBrandProduct } from '../../lib/with-brand-product';
const frontendConfig = {
    constants: {
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '(855)-236-6302',
        CLAIMS_PHONE: '(855)-223-9294',
        CLAIMS_EMAIL: 'claimsupport@ourbranch.com',
        AGENCY_SUPPORT_PHONE: '(855) 438-5411',
        AGENCY_SUPPORT_HOURS: 'Mon-Fri, 9am-7pm EST',
        MEMBER_COMMS_EMAIL: 'membercomms@ourbranch.com',
        SMS_SHORTCODE: '230230',
        TERMS_OF_USE_URL: 'https://www.ourbranch.com/s/blog/terms-of-use',
        COMMUNICATIONS_CONSENT_URL: 'https://www.ourbranch.com/s/blog/communication-consent/',
        IOS_APP_STORE_URL: 'https://apps.apple.com/us/app/branch-insurance/id1437502167',
        ANDROID_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.branch.accountmobile',
        SMALL_BILLING_NOTE: 'Note: There is no additional fee for paying with credit card.'
    },
    theme: {
        palette: null,
        loaderColor: '#527059',
        showLogoInLoader: true,
        showAccountBackgroundHero: true,
        logoWidthDesktop: 320,
        logoWidthMobile: 230,
        logoVerticalWidthDesktop: 124,
        logoVerticalWidthMobile: 102
    },
    config: {}
};
const brand = withBrandProduct(branch, frontendConfig);
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
